<template>
  <div class="table-wrapper cover-content project-list">
    <div class="boxList" v-loading="loading">
      <Row>
        <Col :span="6">
          <div style="font-size: 28px; font-weight: 900">
            项目名称: {{ projectName }}
          </div>
        </Col>
      </Row>
      <div class="boxConter">
        <Form
          ref="formCustom"
          :model="formCustom"
          :label-width="140"
          :rules="ruleValidate"
        >
          <FormItem label="联审平台项目代码:" prop="businessKey">
            <Input
              type="text"
              v-model="formCustom.businessKey"
              :disabled="!showModal"
            ></Input>
            <div style="color: red">查询地址：http://tzxm.hubei.gov.cn/点击信息公开查询</div>
          </FormItem>
          <FormItem label="工地码:" prop="placeId">
            <Input
              type="text"
              v-model="formCustom.placeId"
              :disabled="!showModal"
            ></Input>
          </FormItem>
          <FormItem style="text-align: right">
            <Button v-if="!showModal" type="primary" @click="showModal=true"
              >编辑</Button
            >
            <Button
              v-if="showModal"
              type="primary"
              @click="handleReset('formCustom')"
              style="margin-left: 8px"
              >保存</Button
            >
            <Button
              v-if="showModal"
              @click="handleSubmit(false)"
              style="margin-left: 8px"
              >取消</Button
            >
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formCustom: {
        businessKey: "",
        placeId: "",
        pushUrl: "",
      },
      ruleValidate: {
        businessKey: [
          {
            required: true,
            message: "请填写在线审批监管平台项目代码",
            trigger: "blur",
          },
        ],
        placeId: [
          {
            required: true,
            message: "请填写工地码",
            trigger: "blur",
          },
        ],
      },
      systemId: "",
      loading: true,
      projectId: "",
      projectName: "",
      showModal: false,
      rowDataList: [],
    };
  },
  created() {
    (this.projectId = this.$route.query.projectId),
      (this.projectName = this.$route.query.projectName),
      (this.systemId = this.$route.query.systemId);
    this.getPushDetails();
  },
  methods: {
    getPushDetails() {
      this.loading = true;
      this.axios({
        method: "get",
        url: "/push/getPushDataProjectBusinessKey",
        params: {
          projectId: this.projectId
        },
      }).then((response) => {
        this.loading = false;
        if (response.data.success) {
          this.formCustom = response.data.data;
        }
      });
    },
    handleSubmit(val) {
      this.$refs.formCustom.resetFields();
      this.showModal = val;
      this.getPushDetails();
    },
    handleReset() {
      this.$refs.formCustom.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            id: this.projectId,
            businessKey: this.formCustom.businessKey,
            placeId: this.formCustom.placeId,
          };
          this.axios({
            method: "post",
            url: "/push/savePushDataProjectBusinessKey",
            data,
          }).then((response) => {
            this.loading = false;
            if (response.data.success) {
              this.showModal = false;
              this.$Message.success("保存成功！");
            } else {
              this.$Message.success("保存失败！");
            }
            this.getPushDetails();
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.boxList {
  margin: 24px;
  .boxConter {
    margin-top: 40px;
    width: 30%;
  }
}
</style>
